import UpdateTransferModal from './UpdateTransferModal'

export default UpdateTransferModal
